export enum PageEnum {
    // 根目录
    ROOT = '/',
    // 未登录首页
    INDEX = '/index',
    //登录页面
    LOGIN = '/login',
    //无权限页面
    ERROR_403 = '/403',
    // 页面不存在
    ERROR_404 = '/404',
    // 最新公告
    LATEST_NOTICE = '/index/latest_notice',
    // 备案流程
    FILING_FLOW = '/index/filing_flow',
    // 法律法规
    LAWS_REGULATIONS = '/index/laws_regulations',
    // 系统帮助
    SYSTEM_HELP = '/index/system_help',
    // 免费注册  //新的注册页面
    REGISTER = '/register',
    //查看详情页面
    DETAIl = '/index/details_all'
}
